
<ng-template #vcr></ng-template>